module.exports = __webpack_public_path__ + "static/media/Drughelp_care_How_To_Video_v1_small.ca5229a9.mp4";